// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rm-2";
export var messageContent = "_rm-0";
export var messagesScroll = "_rm-1";
export var shimmer = "_rm-3";
export var shimmerW100 = "_rm-4";
export var shimmerW70 = "_rm-8";
export var shimmerW80 = "_rm-7";
export var shimmerW85 = "_rm-6";
export var shimmerW90 = "_rm-5";